import { CollapseInformation, TopWave } from '../../components'

export const Credits = () => {
	return (
		<div className='iconsContainer'>
			<TopWave />
			<div className='pb-5'>
				<div className='iconsCard ownShadow'>
					<CollapseInformation name='Iconos de Flaticon' id='flaticonIconos'>
						<ul>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/grafico-circular'
									target='_blank'
									rel='noreferrer'
									title='gráfico circular iconos'
									className=' text-decoration-none'
								>
									Gráfico circular iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.com/free-icons/physics'
									target='_blank'
									rel='noreferrer'
									title='physics icons'
									className=' text-decoration-none'
								>
									Iconos de física creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/figura-geometrica'
									target='_blank'
									rel='noreferrer'
									title='figura geométrica iconos'
									className=' text-decoration-none'
								>
									Figura geométrica icono creado por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.com/free-icons/english-language'
									target='_blank'
									rel='noreferrer'
									title='english language icons'
									className=' text-decoration-none'
								>
									Iconos de inglés creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.com/free-icons/flask'
									target='_blank'
									rel='noreferrer'
									title='flask icons'
									className=' text-decoration-none'
								>
									Flask iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.com/free-icons/law'
									target='_blank'
									rel='noreferrer'
									title='law icons'
									className=' text-decoration-none'
								>
									Iconos de leyes creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.com/free-icons/pythagoras'
									target='_blank'
									rel='noreferrer'
									title='pythagoras icons'
									className=' text-decoration-none'
								>
									Iconos de Pitágoras creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/filosofia'
									target='_blank'
									rel='noreferrer'
									title='filosofia iconos'
									className=' text-decoration-none'
								>
									Filosofía iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.com/free-icons/dna'
									title='dna icons'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Dna icons creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.com/free-icons/tool-box'
									title='tool box icons'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Tool box iconos creados por pongsakornRed - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/sonreir'
									title='sonreír iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Sol íconos creador por denimao - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/globos'
									title='globos iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Globos iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/bateria'
									title='batería iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Batería icono creado por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/esmeralda'
									title='esmeralda iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Esmeralda iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/tenis'
									title='tenis iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Tenis iconos creados por AmethystDesign - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/arbol-de-la-vida'
									title='arbol-de-la-vida iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Arbol de la vida iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/gene'
									title='gene iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Gene iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/aire'
									title='aire iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Aire iconos creados por torskaya - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/cepillo-de-dientes'
									title='cepillo-de-dientes iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Cepillo-de-dientes iconos creados por Victoruler - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/television'
									title='televisión iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Televisión iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/sal'
									title='sal iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Sal iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/coliflor'
									title='coliflor iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Coliflor iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/aeronave'
									title='aeronave iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Aeronave iconos creados por Pause08 - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/semiconductor'
									title='semiconductor iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Semiconductor iconos creados por Natthapong - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/cajita-de-cerillas'
									title='cajita de cerillas iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Cajita de cerillas iconos creados por Zulfa Mahendra -
									Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/compost'
									title='compost iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Compost iconos creados por surang - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/piscina'
									title='piscina iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Piscina iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/idea'
									title='idea iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Idea iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/platanos'
									title='plátanos iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Plátanos iconos creados por Luvdat - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/fluorescente'
									title='fluorescente iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Fluorescente iconos creados por Flat Icons - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/bote-de-jack'
									title='bote de jack iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Bote de jack iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/cubiertos-de-bebe'
									title='cubiertos de bebe iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Cubiertos de bebe iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/lata-de-refresco'
									title='lata de refresco iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Lata de refresco iconos creados por andinur - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/puente'
									title='puente iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Puente iconos creados por max.icons - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/positivo-y-negativo'
									title='positivo-y-negativo iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Positivo-y-negativo iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/moneda'
									title='moneda iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Moneda iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/cable-de-energia'
									title='cable de energía iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Cable de energía iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/trompeta'
									title='trompeta iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Trompeta iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/diodo'
									title='diodo iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Diodo iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/fibra-optica'
									title='fibra óptica iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Fibra óptica iconos creados por Chattapat - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/veneno'
									title='veneno iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Veneno iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/maquina-de-copiar'
									title='maquina de copiar iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Maquina de copiar iconos creados por manshagraphics - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/pelicula'
									title='película iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Película iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/antorcha'
									title='antorcha iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Antorcha iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/satelite'
									title='satélite iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Satélite iconos creados por Dighital - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/fuegos-artificiales'
									title='fuegos artificiales iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Fuegos artificiales iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/maquina-de-corte-por-laser'
									title='máquina de corte por láser iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Máquina de corte por láser iconos creados por Smashicons -
									Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/tubo-de-ensayo'
									title='tubo de ensayo iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Tubo de ensayo iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/entrenar'
									title='entrenar iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Entrenar iconos creados por Mihimihi - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/alicate'
									title='alicate iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Alicate iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/rayos-x'
									title='rayos x iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Rayos x iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/interruptor-abierto'
									title='interruptor abierto iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Interruptor abierto iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/estudio'
									title='estudio iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Estudio iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/corona-dental'
									title='corona-dental iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Corona-dental iconos creados por Nikita Golubev - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/medalla-de-plata'
									title='medalla de plata iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Medalla de plata iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/toda-la-vida'
									title='toda-la-vida iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Toda-la-vida iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/pantalla-tactil'
									title='pantalla táctil iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Pantalla táctil iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/comida-enlatada'
									title='comida enlatada iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Comida enlatada iconos creados por smashingstocks - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/bateria'
									title='batería iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Batería iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/desinfectar'
									title='desinfectar iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Desinfectar iconos creados por justicon - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/faro'
									title='faro iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Faro iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/reloj-inteligente'
									title='reloj inteligente iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Reloj inteligente iconos creados por Pixel perfect - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/esqueleto'
									title='esqueleto iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Esqueleto iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/generador'
									title='generador iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Generador iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/aplicacion'
									title='aplicación iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Aplicación iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/idea'
									title='idea iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Idea iconos creados por Icon home - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/matematicas'
									title='matemáticas iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Matemáticas iconos creados por Freepik - Flaticon
								</a>
							</li>
							<li>
								<a
									href='https://www.flaticon.es/iconos-gratis/asistencia'
									title='asistencia iconos'
									className=' text-decoration-none'
									target='_blank'
									rel='noreferrer'
								>
									Asistencia iconos creados por Freepik - Flaticon
								</a>
							</li>
						</ul>
					</CollapseInformation>
				</div>
			</div>
		</div>
	)
}
